var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.895.705a1.011 1.011 0 00-1.788 0L.287 9.746c-.079.149-.12.314-.12.483 0 .564.454 1.02 1.014 1.02h9.638c.167 0 .332-.04.48-.12.493-.267.678-.886.414-1.383L6.895.706zm-.84.347l.015.007.014.01c.019.012.034.03.045.05l4.817 9.041a.146.146 0 01-.127.215H1.18a.145.145 0 01-.128-.215l4.82-9.041a.145.145 0 01.181-.067zm.528 5.823a.583.583 0 11-1.166 0V4.833a.583.583 0 111.166 0v2.042zM6 8.187A.656.656 0 106 9.5a.656.656 0 000-1.313z"
  })));
}

export default SvgAlertTriangle;